import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';

import ReactGA from 'react-ga';

import classes from './Login.css';

class Login extends Component {

	state = {
		email:'',
		password:'',
		typeOfForm:'login',

		name:'',
		repeatPassword:'',
		tel:''

	}

    componentDidMount() {
        // custom rule will have name 'isPasswordMatch'
        ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
            if (value !== this.state.password) {
                return false;
            }
            return true;
        });
        // custom rule will have name 'isMobilePhone'
        ValidatorForm.addValidationRule('isMobilePhone', (value) => {
			var patt = /^(06\d)\d{6,9}$/i;
			return patt.test(value);
		});
		
    }

	setErrorMessage = (message) => {
		var newState = {
			...this.state,
			errorText: message
		}
		this.setState(newState);
		this.startErrorFadeOut();
	}

	startErrorFadeOut = () => {
		this.setTimeout(function () {
			this.props.onResetError();
		},2000);
	}

	handleChange = (event) => {
		const {name,value} = event.target;
		let newState = {
			...this.state,
			[name]:value
		}
		this.setState(newState);
	};


    handleSubmit = (event) => {
		event.preventDefault();
		if (this.state.typeOfForm==='login') {

			ReactGA.event({
				category: 'Authentication Action',
				action: 'Login',
			});

			this.props.onAuth(this.state.email, this.state.password, this.state.typeOfForm, null, null);
		} else if (this.state.typeOfForm==='signup') {

			ReactGA.event({
				category: 'Authentication Action',
				action: 'SignUp',
			});
		
			this.props.onAuth(this.state.email, this.state.password, this.state.typeOfForm, this.state.name, this.state.tel);
		} else if (this.state.typeOfForm==='forgot') {

			ReactGA.event({
				category: 'Authentication Action',
				action: 'Password forgot',
			});
		
			this.props.onAuth(this.state.email, null, 'forgot', null, null);
		}
	};

	switchAuthModeHandler = (type) => {
		let newState = {
			...this.state,
			typeOfForm: type,
		}
		this.setState(newState);
	};

	handleErrorShow = () => {
		clearTimeout(this.clearErrorTimeout);
		this.clearErrorTimeout = setTimeout( () => {
			this.props.onResetError();
		}, 3000);
	};

    componentWillUnmount() {
		clearTimeout(this.clearErrorTimeout);
	}
	
	render () {
		let errorClass = [classes.errorWindow, classes.errorWindowHide];
		let errorText = ' ';
		if ( this.props.error !== null ) {
			errorClass = [classes.errorWindow];
			//console.log(this.props.error.message);
			this.handleErrorShow();
			switch (this.props.error.message) {
				case 'EMAIL_NOT_FOUND':
					errorText = 'E-mail nije pronađen! Kreirajte novi nalog.';
					break;
				case 'INVALID_PASSWORD':
					errorText = 'Lozinka je netačna! Pokušajte ponovo.';
					break;
				case 'TOO_MANY_ATTEMPTS_TRY_LATER':
					errorText = 'Previše pogrešnih pokušaja! Pokušajte kasnije.';
					break;
				case 'EMAIL_EXISTS':
					errorText = 'Uneseni email je već registrovan.';
					break;
				case 'PHONE_TAKEN':
					errorText = 'Uneseni telefon je već registrovan.';
					break;
				case 'USER_DISABLED':
					errorText = 'Nalog je onemogućen.';
					break;
				case 'EMAIL_RESET_SENT':
					errorText = 'E-mail za resetovanje lozinke je poslat!';
					errorClass = [classes.errorWindow, classes.infoWindow];
					break;
				default:
					errorText = ' ';
			}
		} else {
			errorText= '&nbsp;';
		}

		let switchText = '';
		let titleText = '';

		if (this.state.typeOfForm === 'signup') {
			switchText = 'Prijavite se na svoj nalog';
			titleText = 'Registrujte se';
		} else if (this.state.typeOfForm === 'login') {
			switchText = 'Registrujte se';
			titleText = 'Prijavite se';
		} else if (this.state.typeOfForm === 'forgot') {
			switchText = 'Prijavite se na svoj nalog';
			titleText = 'Zaboravljena lozinka';
		}

		return (
			<div className={classes.loginWindow}>
				<div className={classes.loginTitle}>
					<Typography 
						align='center'
						gutterBottom 
						variant='title'>
							{titleText}
					</Typography>
				</div>
				<ValidatorForm
					ref="form"
					onSubmit={this.handleSubmit}
					onError={errors => console.log(errors)}
					className={classes.form}
				>
				{
					(this.state.typeOfForm==='signup')
					? (
					<TextValidator
						className={classes.textField}
						margin="normal"
						autoComplete="off"
						label="Ime i prezime"
						name="name"
						value={this.state.name}
						onChange={this.handleChange}
						validators={['required', 'minStringLength:6']}
						errorMessages={['Ovo polje je obavezno', 'Vrednost mora biti veća od 6 karaktera']}
					/>
					)
					: null
				}
				<TextValidator
						className={classes.textField}
						autoFocus
						margin="normal"
						autoComplete="off"
						label="E-mail adresa"
						name="email"
						value={this.state.email}
						onChange={this.handleChange}
						validators={['required', 'isEmail']}
						errorMessages={['Ovo polje je obavezno', 'E-mail nije validan']}
					/>
				{
					(this.state.typeOfForm==='signup')
					? (
					<TextValidator
						className={classes.textField}
						margin="normal"
						autoComplete="off"
						label="Broj telefona"
						name="tel"
						value={this.state.tel}
						onChange={this.handleChange}
						validators={['required', 'isMobilePhone']}
						errorMessages={['Ovo polje je obavezno', 'Upišite broj mobilnog telefona u formi 06XXXXXXXX']}
					/>
					)
					: null
				}
				{
					(this.state.typeOfForm==='login' || this.state.typeOfForm==='signup')
					? (
					<TextValidator
						autoComplete="new-password"
						id="password-input"
						name="password"
						label="Lozinka"
						className={classes.textField}
						type="password"
						margin="normal"
						onChange={this.handleChange}

						value={this.state.password}
						validators={['required','minStringLength:6']}
						errorMessages={['Ovo polje je obavezno','Dužina lozinke mora biti najmanje 6 karaktera']}
					/>
					)
					: null
				}
				{
					(this.state.typeOfForm==='signup')
					? (
					<TextValidator
						id="password-input2"
						name="repeatPassword"
						label="Potvrda lozinke"
						className={classes.textField}
						type="password"
						margin="normal"
						onChange={this.handleChange}

						value={this.state.repeatPassword}
						validators={['required','minStringLength:6','isPasswordMatch']}
						errorMessages={['Ovo polje je obavezno','Dužina lozinke mora biti najmanje 6 karaktera', 'Lozinke se ne podudaraju']}
					/>
					)
					: null
				}

					<div className={errorClass.join(' ')}>
						{errorText}
					</div>
					<Button variant="outlined" className={classes.button} type='submit'>
						Potvrdite
					</Button>

				</ValidatorForm>

				<div className={classes.buttonSwitchHolder}>
					<Button 
						color="primary" 
						className={classes.buttonSwitch} 
						onClick={ () => {
							if (this.state.typeOfForm==='login') {
								this.switchAuthModeHandler('signup');
							} else if (this.state.typeOfForm==='signup') {
								this.switchAuthModeHandler('login');
							} else {
								this.switchAuthModeHandler('login');
							}
						} }
					>
						{switchText}
					</Button>
				{
					(this.state.typeOfForm==='login')
					? (
					<Button 
						color="secondary" 
						className={classes.buttonSwitch} 
						onClick={ () => {
							this.switchAuthModeHandler('forgot');
						} }
					>
						Zaboravljena lozinka
					</Button>
					)
					: null
				}
				</div>
			</div>
		);
	}
};

const mapStateToProps = state => {
	return {
		loading: state.auth.loading,
		error: state.auth.error,
		isAuthenticated: state.auth.token !== null,
	}
}

const mapDispatchToProps = dispatch => {
	return {
		onAuth: (email, password, isLogin, name, phone) => dispatch(actions.auth(email,password,isLogin,name,phone)),
		onResetError: () => dispatch(actions.resetErrorState()),
	};
};

export default connect(mapStateToProps,mapDispatchToProps)(Login);


// WEBPACK FOOTER //
// ./src/containers/Login/Login.js